
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '@/components/ui/button';
import { LogOut, Home, FileText, Users, Settings, LayoutDashboard, Image, Palette } from 'lucide-react';
import AdminDashboard from '@/components/admin/AdminDashboard';
import { 
  SidebarProvider, 
  Sidebar, 
  SidebarContent, 
  SidebarMenu, 
  SidebarMenuItem, 
  SidebarMenuButton,
  SidebarHeader, 
  SidebarGroup, 
  SidebarGroupLabel,
  SidebarGroupContent,
  SidebarFooter
} from '@/components/ui/sidebar';

const Admin = () => {
  const { user, isAuthenticated, logout, hasPermission } = useAuth();

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <SidebarProvider>
      <div className="min-h-screen bg-gray-50 flex w-full">
        <Sidebar>
          <SidebarHeader className="p-4 border-b">
            <h2 className="text-xl font-bold">TORO Admin</h2>
            <p className="text-sm text-muted-foreground">
              <span className="font-medium">{user?.name}</span> ({user?.role})
            </p>
          </SidebarHeader>

          <SidebarContent>
            <SidebarGroup>
              <SidebarGroupLabel>Main</SidebarGroupLabel>
              <SidebarGroupContent>
                <SidebarMenu>
                  <SidebarMenuItem>
                    <SidebarMenuButton tooltip="Dashboard">
                      <a href="#dashboard">
                        <LayoutDashboard className="h-4 w-4 mr-2" />
                        <span>Dashboard</span>
                      </a>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                  
                  {hasPermission('editor') && (
                    <>
                      <SidebarMenuItem>
                        <SidebarMenuButton tooltip="Content">
                          <a href="#content">
                            <FileText className="h-4 w-4 mr-2" />
                            <span>Content</span>
                          </a>
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                      
                      <SidebarMenuItem>
                        <SidebarMenuButton tooltip="Media">
                          <a href="#media">
                            <Image className="h-4 w-4 mr-2" />
                            <span>Media</span>
                          </a>
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                      
                      <SidebarMenuItem>
                        <SidebarMenuButton tooltip="Brand Kit">
                          <a href="#brand">
                            <Palette className="h-4 w-4 mr-2" />
                            <span>Brand Kit</span>
                          </a>
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                      
                      <SidebarMenuItem>
                        <SidebarMenuButton tooltip="Services">
                          <a href="#services">
                            <Home className="h-4 w-4 mr-2" />
                            <span>Services</span>
                          </a>
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                    </>
                  )}
                  
                  {hasPermission('admin') && (
                    <SidebarMenuItem>
                      <SidebarMenuButton tooltip="Users">
                        <a href="#users">
                          <Users className="h-4 w-4 mr-2" />
                          <span>Users</span>
                        </a>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  )}
                  
                  <SidebarMenuItem>
                    <SidebarMenuButton tooltip="Settings">
                      <a href="#settings">
                        <Settings className="h-4 w-4 mr-2" />
                        <span>Settings</span>
                      </a>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          </SidebarContent>
          
          <SidebarFooter className="border-t p-4">
            <Button variant="outline" className="w-full justify-start" onClick={logout}>
              <LogOut className="h-4 w-4 mr-2" />
              Log out
            </Button>
          </SidebarFooter>
        </Sidebar>

        {/* Main content area */}
        <div className="flex-1 p-6">
          <AdminDashboard />
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Admin;
